import { FaApple, FaAndroid, FaLaptop } from "react-icons/fa";
import Language_i18 from '../../../../js/useNationalLanguage.jsx';
const InfoLink = ({ item }) => {
    const { i18n, lang } = Language_i18();

    let obj;
    try {
        obj = JSON.parse(item.description);
        // Nếu parse thành công, obj đã là object JSON
    } catch (err) {
        console.error("Failed to parse JSON:", err);
        // Nếu không parse được, bạn có thể gán mặc định hoặc giữ nguyên chuỗi
        obj = { vi: item.description, en: item.description };
    }
    // nếu obj[lang] là object thì dùng .description, còn nếu là string thì lấy nguyên
    const description =
        (typeof obj[lang] === 'object'
            ? obj[lang]?.description
            : obj[lang]) ||
        item.description ||
        '';

    return (
        <>
            {item.description.includes('<div>') ? (
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
            ) : (
                <p className="mb-1 text-gray-700">{description}</p>
            )}

            <div className="border-t border-gray-300 my-1"></div>
            <div className="grid grid-cols-5 gap-4 items-center">
                <div className="flex flex-col mb-0">
                    <div className="flex items-center">
                        <span className="text-sm mr-1">🌾</span>
                        {item.type_api === 'offerwall' ? (
                            <span className="text-base font-semibold text-blue-600">
                                {item.price}
                            </span>
                        ) : (
                            <span className="text-lg font-semibold text-blue-600">
                                {item.price}
                            </span>
                        )}
                    </div>
                    {item.type_api === 'offerwall' ? (
                        <span className="text-base font-semibold text-blue-600">Coins/Day</span>
                    ) : (
                        <span className="text-lg font-semibold text-blue-600">Coins</span>
                    )}
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    🌲 Delay {item.time} s
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    <div className="leading-tight">
                        {item.minorder === '0' ? (
                            <div className="text-xs">
                                👁 {item.views}/{parseFloat((1 / item.maxorder).toFixed(2))} views_day
                            </div>
                        ) : (
                            <div className="text-xs">👁 {item.views}/{item.maxorder} views_day</div>
                        )}
                        {item?.mission_quantity !== undefined &&
                            item?.mission_quantity !== null &&
                            item?.mission_quantity !== '' && (
                                <div className="text-xs text-gray-500">views_limit {item.mission_quantity}</div>
                            )}
                    </div>
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block">
                    <div className="flex text-base">
                        {item.type_api.includes('only_app') ? (
                            <> <FaApple /><FaAndroid /> </>
                        ) : (
                            <> <FaLaptop /><FaApple /><FaAndroid /> </>
                        )}
                    </div>
                    device
                </div>
                <div className="text-sm text-gray-600 mb-0 inline-block text-center">
                    <div className="text-base font-semibold text-gray-800">
                        {item?.data_time && item.data_time !== false
                            ? `${Math.round(item.data_time.average_time)}s`
                            : 'none'}
                    </div>
                    <div className="text-xs text-gray-500">time</div>
                </div>
            </div>
        </>
    );
};

export default InfoLink;
